import { Link } from "react-router-dom";
import { testimonials } from "@/mocks/faqs";
import SectionHeading from "@/components/base/SectionHeading";

const stats = [
  { value: "10+", label: "每日更新内容" },
  { value: "5", label: "现场主题分区" },
  { value: "24h", label: "热点跟进周期" },
  { value: "100%", label: "标注核实状态" },
];

export default function BrandSection() {
  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto max-w-[1240px] px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <SectionHeading
              kicker="ABOUT"
              title="一个只做现场与情报的中文内容站"
              desc="看料大瓜不追逐情绪化的标题，而是把注意力放在「发生了什么」和「接下来会怎样」。我们用时间线交代过程，用分级说明信息可靠程度，让每一个想认真了解事件的人，都能在几分钟内跟上进度。"
            />
            <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-4">
              {stats.map((stat) => (
                <div key={stat.label} className="rounded-lg border border-background-200 bg-background-100 p-4">
                  <p className="font-heading text-xl font-black text-primary-600 md:text-2xl">
                    {stat.value}
                  </p>
                  <p className="mt-1 text-xs text-foreground-600">{stat.label}</p>
                </div>
              ))}
            </div>
            <Link
              to="/about"
              className="mt-8 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              了解我们的内容原则
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="flex flex-col gap-4">
            {testimonials.map((item) => (
              <figure
                key={item.name}
                className="rounded-lg border border-background-200 bg-background-100 p-5"
              >
                <i className="ri-double-quotes-l text-2xl text-accent-500" />
                <blockquote className="mt-2 text-sm leading-relaxed text-foreground-700">
                  {item.text}
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200 pt-4">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-secondary-200 font-heading text-sm font-bold text-secondary-900">
                    {item.name.slice(0, 1)}
                  </span>
                  <span className="flex flex-col">
                    <span className="text-sm font-medium text-foreground-900">{item.name}</span>
                    <span className="text-xs text-foreground-500">{item.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}